import { render, staticRenderFns } from "./PlantillaLogin.vue?vue&type=template&id=7f60329c&"
import script from "./PlantillaLogin.vue?vue&type=script&lang=js&"
export * from "./PlantillaLogin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports